import { render, staticRenderFns } from "./PuzzleListItem.vue?vue&type=template&id=6c8cf96a&scoped=true&"
import script from "./PuzzleListItem.vue?vue&type=script&lang=js&"
export * from "./PuzzleListItem.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleListItem.vue?vue&type=style&index=0&id=6c8cf96a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8cf96a",
  null
  
)

component.options.__file = "PuzzleListItem.vue"
export default component.exports